import React from "react";
import { useDrop } from "react-dnd";
import coin_C from "../images/coin_C.png";
import coin_I from "../images/coin_I.png";
import coin_L from "../images/coin_L.png";
import coin_V from "../images/coin_V.png";
import coin_X from "../images/coin_X.png";
import "./Box.css";

const coinImages = {
  0: coin_C,
  1: coin_L,
  2: coin_X,
  3: coin_V,
  4: coin_I,
};

/* 
This component implements a box into which coins can be dropped.
The coins can be displayed either grouped or not grouped.
Parts of it were created with the help of LLMs.
*/
function Box({ id, coins, onDropCoin, coinSize }) {
  const [, drop] = useDrop({
    accept: "coin",
    drop: (item, monitor) => {
      if (!monitor.didDrop()) {
        onDropCoin(item.id, id); // item.id is 2d-array. item[0] is index of coin that was dropped, that index corresponds to a char (e.g. in Roman 2 = 'X'). id is the index of the box it was dropped in.
      }
    },
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
      canDrop: !!monitor.canDrop(),
    }),
  });

  const coinStyle = {
    width: coinSize+"dvh",
    height: coinSize+"dvh",
    display: "flex",
    justifyContent: "center",
    zIndex: 1,
  };

  const boxStyle = {
    display: "flex",
    flexWrap: "wrap",
    maxWidth: 5*coinSize+"dvh", // By default five coins fit in a row in the box.
    minWidth: 5*coinSize+"dvh",
    maxHeight: 3*coinSize+"dvh", // At most three rows of coins fit in the box.
    minHeight: 2*coinSize+"dvh",
    zIndex: 0,
    filter: "drop-shadow(0svh 0svh 0.6svh rgba(0, 0, 0, 0.5))",
    borderRadius: "0.25em",
    alignItems: "center",
  };

  const dropStyle = {
    maxWidth: "50dvh",
    maxHeight: "15dvh",
    backgroundColor: "none",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    alignContent: "center",
    margin: "2dvh"
  };

  return (
    <div ref={drop} style={dropStyle}>
      <div alt="Box" className="box" style={boxStyle}>
        {Array.from({ length: 5 }, (_, id) => (
          <React.Fragment key={id}>
            {(Array.from({ length: coins[id] }).map((_, coinId) => (
                <div key={coinId} style={coinStyle}>
                  <img src={coinImages[id]} alt="coin" />
                </div>
              ))
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

export default Box;
